export default {
  baseurl: process.env.VUE_APP_BASEURL,
  login_baseurl: process.env.VUE_APP_LOGIN_BASEURL,
  imurl: process.env.VUE_APP_IMURL_BASEURL,
  bburl: process.env.VUE_APP_BBURL_BASEURL
};
/* const VUE_APP_MODE = process.env.VUE_APP_MODE;

const baseUrlMaps = {
  // 本地
  development: {
    baseURL: "/api", // api前缀
    login_baseurl: "/login", // 登录
    imurl: "https://sit.apbenben.com", // IM地址
    benbenurl: "https://sit.apbenben.com/" //犇犇web端地址
  },
  // 测试
  testing: {
    baseURL: "http://test.epc.apware.cn:1314/api",
    login_baseurl: "http://test.epc.apware.cn:1314/login",
    imurl: "https://sit.apbenben.com",
    benbenurl: "https://sit.apbenben.com/" //犇犇web端地址
  },
  // 生产
  production: {
    baseURL: "http://epc.apbenben.com:1212",
    login_baseurl: "http://epc.apbenben.com:1212",
    imurl: "https://im.apbenben.com",
    benbenurl: "https://web.apbenben.com/"
  }
};

export default baseUrlMaps[VUE_APP_MODE]; */
